export default __webpack_public_path__ + "static/media/setting.d8bc4962.svg";